import type { IconProps } from '.';

/**
 * Arrow Bottom Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const ArrowBottomIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8535 15.4393L16.9999 11.2929L17.707 12L12.3535 17.3535L6.99992 12L7.70703 11.2929L11.8535 15.4393L11.8535 6.64642L12.8535 6.64642L12.8535 15.4393Z"
      fill="white"
    />
  </svg>
);

export default ArrowBottomIcon;
